export enum FieldNames {
  Reviewer = 'Referral Details: Sanctions Team Reviewer',
	Reinsurance_Details_Q10 = 'Reinsurance Details: Q10'
}